import React from "react";
import Login from "../component/auth/Login";

const LoginPage = () => {
  return <Login open={true} setLogin={true} />;
};

export default LoginPage;
